import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles, perm }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen grid place-items-center bg-slate-50 dark:bg-slate-950">
      <div className="text-slate-500 text-sm">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  // Permission check (preferred)
  if (perm && !user.permissions?.includes(perm)) return <Navigate to="/" replace />;
  // Legacy role check (fallback)
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
